var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.value ? 'on-toggle-container' : 'off-toggle-container', { disabled: _vm.disabled }],on:{"click":_vm.toggleValue}},[_c('div',{class:[_vm.value ? 'new-on-toggle-circle' : 'new-off-toggle-circle', { disabled: _vm.disabled }]})])
}
var staticRenderFns = []

export { render, staticRenderFns }